// This file is generated by a script. Do not edit this file directly.
import React from "react";
import { Avatar } from "./Avatar";

// given the main avatar size, return the size of the sub avatar
var SUB_AVATAR_SIZE_MAP = {
  xl: 'md',
  lg: 'xs',
  md: '2xs',
  sm: '3xs',
  xs: '3xs'
};

// given the main avatar size, return the offset classname for the sub avatar
var OFFSET_MAP_CLASSNAME = {
  xl: 'cop-bottom-[-8px] cop-right-[-8px]',
  lg: 'cop-bottom-[-4px] cop-right-[-4px]',
  md: 'cop-bottom-[-2px] cop-right-[-2px]',
  sm: 'cop-bottom-[-2px] cop-right-[-2px]',
  xs: 'cop-bottom-[-4px] cop-right-[-4px]'
};
export function UserWithCompanyAvatar(_ref) {
  var size = _ref.size,
    avatarSrc = _ref.avatarSrc,
    fallbackColor = _ref.fallbackColor,
    text = _ref.text,
    icon = _ref.icon,
    companyText = _ref.companyText,
    companyAvatarSrc = _ref.companyAvatarSrc,
    companyAvatarFallbackColor = _ref.companyAvatarFallbackColor,
    companyAvatarIcon = _ref.companyAvatarIcon,
    _ref$useNewColors = _ref.useNewColors,
    useNewColors = _ref$useNewColors === void 0 ? false : _ref$useNewColors;
  return /*#__PURE__*/React.createElement("div", {
    className: "cop-relative cop-h-fit cop-w-fit"
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: avatarSrc,
    fallbackColor: fallbackColor !== null && fallbackColor !== void 0 ? fallbackColor : '',
    text: text,
    alt: text,
    size: size,
    variant: "circle",
    icon: icon,
    useNewColors: useNewColors
  }), companyText && /*#__PURE__*/React.createElement(Avatar, {
    src: companyAvatarSrc !== null && companyAvatarSrc !== void 0 ? companyAvatarSrc : '',
    fallbackColor: companyAvatarFallbackColor !== null && companyAvatarFallbackColor !== void 0 ? companyAvatarFallbackColor : '',
    text: companyText,
    alt: companyText,
    size: SUB_AVATAR_SIZE_MAP[size],
    variant: "rounded",
    className: "!cop-absolute ".concat(OFFSET_MAP_CLASSNAME[size], " cop-box-border"),
    icon: companyAvatarIcon,
    useNewColors: useNewColors
  }));
}
